"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _secBanner = _interopRequireDefault(require("./child/secBanner"));
var _validate = require("@/utils/validate");
var _xcx = require("@/api/xcx");
var _merchantSelect = _interopRequireDefault(require("@/components/merchant/merchantSelect.vue"));
var _default = {
  components: {
    secBanner: _secBanner.default,
    MerchantSelector: _merchantSelect.default
  },
  data: function data() {
    return {
      type: 20,
      //分享配置
      title: '首页广告',
      bannerInfo: {
        status: 0
      },
      bannerList: [],
      itemNumber: 1,
      //子组件secBanner中item的数量
      merchant_id: '',
      bannerstatus: {
        once: false,
        everyday: false,
        times: false,
        start: '',
        end: '',
        version: 1
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    changeswitch: function changeswitch(str) {
      switch (str) {
        case 'once':
          this.bannerstatus.everyday = false;
          this.bannerstatus.times = false;
          break;
        case 'everyday':
          this.bannerstatus.once = false;
          this.bannerstatus.times = false;
          break;
        case 'times':
          this.bannerstatus.once = false;
          this.bannerstatus.everyday = false;
          break;
      }
    },
    handleMerchantIdUpdate: function handleMerchantIdUpdate(merchantId) {
      this.merchant_id = merchantId;
      console.log('this.searchForm', this.merchant_id);
      this.getData();
    },
    init: function init() {
      this.merchant_id = this.sMerchantId;
      this.getData();
    },
    getData: function getData() {
      var _this = this;
      if (!this.merchant_id) {
        this.$message({
          message: '请先选择商户',
          type: 'warning'
        });
        return;
      }
      (0, _xcx.getBannerInfo)({
        type: this.type,
        merchant_id: this.merchant_id
      }).then(function (res) {
        console.log('getBannerInfo', res);
        if (res) {
          _this.bannerInfo = res;
          _this.bannerList = res.banner_list ? res.banner_list : [];
          _this.$refs.secBanner.bannerList = (0, _toConsumableArray2.default)(_this.bannerList);
          if (_this.bannerList.length > 0) {
            _this.bannerstatus.once = _this.bannerList[0].once;
            _this.bannerstatus.everyday = _this.bannerList[0].everyday;
            _this.bannerstatus.times = _this.bannerList[0].times;
            _this.bannerstatus.start = _this.bannerList[0].start;
            _this.bannerstatus.end = _this.bannerList[0].end;
            if (_this.bannerList[0].version) {
              _this.bannerstatus.version = _this.bannerList[0].version + 1;
            } else {
              _this.bannerstatus.version = 1;
            }
          }
        }
      });
    },
    // 保存顶部导航栏
    save: function save() {
      var _this2 = this;
      //处理数据合法性
      if (this.bannerstatus.times) {
        if (!this.bannerstatus.start) {
          this.$message({
            message: '请输入开始时间',
            type: 'warning'
          });
          return;
        }
        if (!this.bannerstatus.end) {
          this.$message({
            message: '请输入结束时间',
            type: 'warning'
          });
          return;
        }
        var starttime = Number(this.bannerstatus.start);
        var endtime = Number(this.bannerstatus.end);
        if (starttime < 25 && starttime > 0) {} else {
          this.$message({
            message: '开始时间必须为1-24之间的整数',
            type: 'warning'
          });
          return;
        }
        if (endtime < 25 && endtime > 0) {} else {
          this.$message({
            message: '结束时间必须为1-24之间的整数',
            type: 'warning'
          });
          return;
        }
        if (endtime - starttime <= 0) {
          this.$message({
            message: '结束时间必须大于开始时间',
            type: 'warning'
          });
          return;
        }
      }
      var list = (0, _toConsumableArray2.default)(this.$refs.secBanner.bannerList);
      if (this.validateBannerList(list)) {
        list[0] = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, list[0]), this.bannerstatus);
        if (!this.merchant_id) {
          this.$message({
            message: '请先选择商户',
            type: 'warning'
          });
          return;
        }
        var param = {
          type: this.type,
          status: this.bannerInfo.status,
          banner_list: JSON.stringify(list),
          merchant_id: this.merchant_id
        };
        (0, _xcx.saveBannerInfo)(param).then(function (res) {
          // console.log('saveBannerInfo', res)
          _this2.getData();
        });
      }
    },
    // 校验轮播图列表
    validateBannerList: function validateBannerList(list) {
      if (list.length === 0) {
        this.$message({
          message: '请添加轮播图',
          type: 'warning'
        });
        return false;
      }
      for (var index = 0; index < list.length; index++) {
        var num = index + 1;
        if (!list[index].img) {
          this.$message({
            message: '请添加轮播图' + num + '的图片',
            type: 'warning'
          });
          return false;
        }
        if (!list[index].jumpUrl) {
          this.$message({
            message: '请添加轮播图' + num + '的链接',
            type: 'warning'
          });
          return false;
        }
      }
      return true;
    }
  }
};
exports.default = _default;